module.exports = __webpack_public_path__ + "img/life-science-nutritional.d447a96e.jpg";